import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ac1dd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fill-in-equipment" }

import ItemInfo from './item-info.vue'
import {
  ref,
  withDefaults,
  watch,
  watchEffect,
  computed,
} from 'vue'
import DeviceList from './device-list.vue'
import ReissueTypeList from './reissue-type-list.vue'
import PopCommonWrap from '@/components/popup/common-wrap.vue'
import type { ItemInfoProps } from './item-info.vue'
import { DatetimePicker } from 'vant'
import type { DeviceListItemType } from './device-list.vue'
import type { ReissueTypeListItemType } from './reissue-type-list.vue'
import type {
  NameplateReissueEquipmentItem,
  FillInEquipmentSetData,
} from '@/types/nameplate-reissue'
import {
  getNameplateReissueEquipment,
  getNameplateReissueEquipmentFlyCode,
} from '@/apis/nameplate-reissue'
import { showToastLoading, clearToast } from '@/utils/tools'
import ProductNumberTypeList from './product-number-type-list.vue'
import dayjs from 'dayjs'

/** 获取当天0点的 Date 对象 */

export default /*#__PURE__*/_defineComponent({
  __name: 'fill-in-equipment',
  props: {
    isEdit: { type: Boolean },
    isCanNext: { type: Boolean }
  },
  emits: ["update:isCanNext"],
  setup(__props: any, { expose, emit }: { emit: ({
  (event: 'update:isCanNext', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isEdit: boolean, isCanNext: boolean };

function getTodayStart(): Date {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
}




const createdAt = ref()
const createdAtPopupShow = ref(false)

let isCanNext = computed({
  get() {
    return props.isCanNext
  },
  set(value) {
    emit('update:isCanNext', value)
  },
})

let snActionShow = ref(false)
let reissueTypeShow = ref(false)
let productNumberActionShow = ref(false)
let productNumbeTypeListData = ref([])
let currentProductNumber = ref()
let pageProductNumber = ref()
function productNumberConfrimHandle(value: string) {
  pageProductNumber.value = value
  currentProductNumber.value = value
  productNumberActionShow.value = false
  let productItem = infoArr.value.find((_) => _.prop === 'product')
  productItem.value = value
}
let currentSn = ref('')
let pageSn = ref('')
let currentRessiueType = ref([])
let pageRessiueType = ref([])
const selectSerialNumberPlaceholder = '请选择设备序列号'
const deviceInfo = [
  {
    title: '设备序列号',
    isRequired: true,
    isShowArrowRight: true,
    value: '',
    valueTip: selectSerialNumberPlaceholder,
    prop: 'sn',
    clickHandle,
  },
  {
    title: '产品型号',
    isRequired: true,
    prop: 'product',
    value: [] as Array<string>,
    valueTip: selectSerialNumberPlaceholder,
    tip: '部分机型在不同地区为不同型号标准，请根据所在地区需要选择产品型号！',
  },
  {
    title: '补办类型',
    prop: 'reissueType',
    value: '',
    isRequired: true,
    valueTip: selectSerialNumberPlaceholder,
    isShowArrowRight: true,
    clickHandle,
  },
  {
    title: '出厂编码',
    prop: 'factoryCode',
    value: '',
    valueTip: selectSerialNumberPlaceholder,
  },
  {
    title: '飞控编码',
    prop: 'flightCode',
    value: '',
    valueError: false,
    valueTip: selectSerialNumberPlaceholder,
  },
  {
    title: '地面站（单控）编码',
    value: '',
    prop: 'groundStation',
    isRequired: true,
    valueTip: selectSerialNumberPlaceholder,
    tip: '请找到遥控器顶部的二维码，填入二维码对应编码',
    formatter: (value: string) => {
      return (value || '').toLocaleUpperCase()
    },
  },
  {
    title: '生产日期',
    // timeType: 'factoryItem',
    value: '',
    prop: 'time',
    valueTip: selectSerialNumberPlaceholder,
    isRequiredBottom: false,
    editTip: '请选择生产日期',
  },
]
let infoArr = ref<Array<ItemInfoProps>>(deviceInfo)
const deviceListData = ref<Array<DeviceListItemType>>([])
const reissueTypeListData = ref<Array<ReissueTypeListItemType>>([])
function clickHandle(item: ItemInfoProps) {
  switch (item.prop) {
    case 'sn':
      currentSn.value = item.value as string
      snActionShow.value = true
      break
    case 'reissueType':
      currentRessiueType.value = pageRessiueType.value.map((_) => _)
      reissueTypeShow.value = true
      break
    case 'product':
      productNumberActionShow.value = true
      break
  }
}
const refreshing = ref(true)
const onRefresh = () => {
  getEquipmentData()
}
/**
 * Watch 1: 监听 isEdit 状态切换
 * 作用：当父组件切换编辑/查看模式时，控制表单项的交互能力
 * - isEdit = true（编辑模式）：显示箭头和点击事件，允许用户选择设备序列号、补办类型
 * - isEdit = false（查看/确认模式）：隐藏箭头和点击事件，仅展示已填写的内容
 * immediate: true 确保组件初始化时立即应用 isEdit 状态
 */
watch(
  () => props.isEdit,
  (isEdit) => {
    infoArr.value = infoArr.value.map((_) => {
      return {
        ..._,
        isEdit,
      }
    })
    // 注意：必须在 map 生成新数组之后再查找，否则拿到的是已被替换掉的旧对象引用
    let snItem = infoArr.value.find((_) => _.prop === 'sn')
    let reissueTypeItem = infoArr.value.find((_) => _.prop === 'reissueType')
    if (isEdit) {
      // 编辑模式：显示箭头和点击事件，允许用户选择设备序列号、补办类型
      snItem.isShowArrowRight = true
      snItem.clickHandle = clickHandle
      reissueTypeItem.isShowArrowRight = true
      reissueTypeItem.clickHandle = clickHandle
    } else {
      // 查看/确认模式：隐藏箭头和点击事件，仅展示已填写的内容
      snItem.isShowArrowRight = false
      delete snItem.clickHandle
      reissueTypeItem.isShowArrowRight = false
      delete reissueTypeItem.clickHandle
    }
  },
  {
    immediate: true,
  }
)
const cacheEquimentListData = ref<Array<NameplateReissueEquipmentItem>>([])
const currentEquimentItem = ref<NameplateReissueEquipmentItem>({})
/**
 * WatchEffect 1: 根据设备序列号是否已选，动态切换表单项的 UI 类型
 * 依赖：infoArr[0].value（设备序列号）、props.isEdit、currentEquimentItem.value.subsidy_factory_at
 * 作用：
 * - groundStation（地面站编码）：
 *   - 已选序列号 + 编辑模式 → 显示为输入框（field），让用户手动输入
 *   - 未选序列号 → 显示为占位提示文字
 * - time（生产日期）：
 *   - 已选序列号 + 编辑模式 + 设备无 subsidy_factory_at → 显示为时间选择器（timePicker）
 *   - 否则 → 展示设备已有的 subsidy_factory_at 或空值，不可编辑
 */
watchEffect(() => {
  let snItem = infoArr.value.find((_) => _.prop === 'sn')

  infoArr.value.forEach((item) => {
    if (item.prop === 'groundStation') {
      if (snItem.value !== '' && props.isEdit) {
        item.uiType = 'field'
        item.valueTip = '请输入地面站（单控）编码'
      } else {
        delete item.uiType
        item.valueTip = selectSerialNumberPlaceholder
      }
    }
    if (item.prop === 'time') {
      if (snItem.value !== '' && props.isEdit && !currentEquimentItem.value.subsidy_factory_at) {
        item.uiType = 'timePicker'
        item.valueTip = item.editTip
      } else {
        delete item.uiType
        item.valueTip = selectSerialNumberPlaceholder
        item.isShowArrowRight = false
        item.value =
          currentEquimentItem.value.subsidy_factory_at ||
          (createdAt.value ? dayjs(createdAt.value).format('YYYY-MM-DD') : '')
      }
    }
  })
})
/**
 * Watch 2: 监听设备序列号的值变化，控制"补办类型"的可点击状态
 * 作用：只有选择了设备序列号后，"补办类型"才允许点击选择
 * - 序列号不为空 → 显示箭头和点击事件，允许选择补办类型
 * - 序列号为空 → 隐藏箭头和点击事件，禁止选择补办类型
 * immediate: true 确保初始化时同步状态
 */
watch(
  () => infoArr.value[0].value,
  () => {
    let value = infoArr.value[0].value
    let reissueTypeItem = infoArr.value.find((_) => _.prop === 'reissueType')
    if (value !== '') {
      reissueTypeItem.clickHandle = clickHandle
      reissueTypeItem.isShowArrowRight = true
    } else {
      delete reissueTypeItem.clickHandle
      reissueTypeItem.isShowArrowRight = false
    }
  },
  {
    immediate: true,
  }
)
/**
 * WatchEffect 2: 表单整体校验，控制"下一步"按钮是否可点击
 * 依赖：pageSn（设备序列号）、pageRessiueType（补办类型）、productItemValue（产品型号）、
 *       flightCodeItem.valueError（飞控编码错误状态）、groundStationItem.value（地面站编码）
 * 校验规则：
 * 1. 必须满足：已选序列号 && 已选补办类型 && 已选产品型号
 * 2. 飞控编码：如果存在且 valueError 为 true（未绑定飞控），则不可下一步
 * 3. 地面站编码（如果存在该字段）：
 *    - 必须为 12 位数字/字母组合
 *    - 不满足时显示红色错误提示，不可下一步
 *    - 满足时恢复默认提示
 * 4. 所有校验通过 → isCanNext = true
 */
watchEffect(() => {
  let flightCodeItem = infoArr.value.find((_) => _.prop === 'flightCode')
  let groundStationItem = infoArr.value.find((_) => _.prop === 'groundStation')
  let productItemValue = infoArr.value.find((_) => _.prop === 'product').value as Array<string>
  if (pageSn.value !== '' && pageRessiueType.value.length && productItemValue.length) {
    if (flightCodeItem && flightCodeItem.valueError) {
      isCanNext.value = false
      return
    }
    if (groundStationItem) {
      console.log('groundStationItemWat', groundStationItem)
      // 校验地面站编码：必须为12位数字/字母组合
      let reg = /^[A-Za-z0-9]+$/
      let value = groundStationItem.value as string
      if (!reg.test(value) || value.length !== 12) {
        // 变换提示
        console.log('value', value.length)
        if (value.length && value.length !== 12) {
          groundStationItem.tip = '请填写由数字和字母组合的12位数'
          groundStationItem.tipStyle = {
            color: 'red',
          }
        } else {
          groundStationItem.tip = '请找到遥控器顶部的二维码，填入二维码对应编码'
          groundStationItem.tipStyle = {}
        }
        isCanNext.value = false
        return
      } else {
        groundStationItem.tip = '请找到遥控器顶部的二维码，填入二维码对应编码'
        groundStationItem.tipStyle = {}
      }
    }
    isCanNext.value = true
  } else {
    isCanNext.value = false
  }
})

async function getEquipmentData() {
  try {
    refreshing.value = true
    let data = await getNameplateReissueEquipment()
    data.forEach((item) => {
      item.serial_number = (item.serial_number || '').toLocaleUpperCase()
    })
    cacheEquimentListData.value = data || []
    deviceListData.value = (data || []).map((_) => {
      return {
        sn: _.serial_number,
        productText: _.name,
      }
    })
    refreshing.value = false
  } catch (e) {
    refreshing.value = false

    console.log(e)
  }
}
getEquipmentData()
function deviceListConfrimHandle(value: string) {
  snActionShow.value = false
  currentEquimentItem.value = cacheEquimentListData.value.find((_) => _.serial_number === value)
  const factoryAtValue = currentEquimentItem.value.factory_at
    ? currentEquimentItem.value?.factory_at?.split(' ')?.[0]
    : ''
  console.log('factoryAtValue', factoryAtValue)
  createdAt.value = factoryAtValue ? new Date(factoryAtValue) : getTodayStart()
  console.log('createdAt.value', createdAt.value)
  pageSn.value = currentEquimentItem.value.serial_number
  //设置相应的值
  // 设备机型类型 UAV 无人机 AUTO 自驾仪 UGV 无人车 AUTO_V2 自驾仪2代
  let isAutopilot = currentEquimentItem.value.model_type?.indexOf('AUTO') === 0
  let isCar = currentEquimentItem.value.model_type === 'UGV'
  if (isCar) {
    // 不直接复用 deviceInfo 原始对象（其 clickHandle 等可能已被 isEdit watcher 删除），用浅拷贝生成新数组
    let isCarDeviceInfo = deviceInfo
      .filter((_) => !['flightCode', 'groundStation'].includes(_.prop))
      .map((_) => ({ ..._ }))
    infoArr.value = isCarDeviceInfo
  } else if (isAutopilot) {
    let isAutopilotDeviceInfo = deviceInfo.filter((_) => !['groundStation'].includes(_.prop))
    infoArr.value = isAutopilotDeviceInfo.map((item) => {
      const isProductItem = item.prop === 'product'
      return {
        ...item,
        // isShowArrowRight: isProductItem ? true : item.isShowArrowRight,
        tip: isProductItem ? '部分机型存在不同型号编码，请根据实际情况选择！' : item.tip,
      }
    })
  } else {
    infoArr.value = deviceInfo.map((_) => ({ ..._ }))
  }

  // 重置产品型号和补办类型
  currentRessiueType.value = []
  pageRessiueType.value = []
  currentProductNumber.value = []
  pageProductNumber.value = []
  infoArr.value = infoArr.value.map((_) => {
    switch (_.prop) {
      case 'sn':
        _.value = currentEquimentItem.value.serial_number
        // 显式恢复点击能力：模板对象的 clickHandle 可能已被 isEdit watcher 删除
        if (props.isEdit) {
          _.clickHandle = clickHandle
          _.isShowArrowRight = true
        }
        break
      case 'product':
        _.value = []
        if (currentEquimentItem.value.product_models.length === 1) {
          _.value = currentEquimentItem.value.product_models[0]
          delete _.clickHandle
          _.isShowArrowRight = false
        } else {
          _.valueTip = '请选择产品型号'
          _.clickHandle = clickHandle
          _.isShowArrowRight = true
        }
        productNumbeTypeListData.value = currentEquimentItem.value.product_models.map((_) => {
          return {
            label: _,
            value: _,
          }
        })
        break
      case 'reissueType':
        // 设置铭牌类型
        _.value = ''
        _.valueTip = '请选择补办类型'
        // 直接恢复点击能力，不依赖 sn 值变化的 watch（重选同一设备时 sn 值不变不会触发该 watch）
        if (props.isEdit) {
          _.clickHandle = clickHandle
          _.isShowArrowRight = true
        } else {
          delete _.clickHandle
          _.isShowArrowRight = false
        }
        reissueTypeListData.value = Object.keys(currentEquimentItem.value.apply_namplate_types).map(
          (_: string) => {
            return {
              value: _,
              label: currentEquimentItem.value.apply_namplate_types[_],
            }
          }
        )
        break
      case 'factoryCode':
        _.value = currentEquimentItem.value.serial_number
        break
      case 'flightCode':
        _.value = ''
        getFlyCode()
        break
      case 'groundStation':
        _.value = ''
        break
      case 'time':
        _.value = currentEquimentItem.value.factory_at
          ? currentEquimentItem.value.factory_at.split(' ')[0]
          : ''
        if (currentEquimentItem.value.serial_number !== '' && props.isEdit) {
          _.uiType = 'timePicker'
          _.valueTip = _.editTip
          _.isShowArrowRight = true
        } else {
          delete _.uiType
          _.valueTip = selectSerialNumberPlaceholder
        }
        break
    }
    return _
  })
}
function reissueTypeConfrimHandle(value: Array<string>) {
  let reissueTypeItem = infoArr.value.find((_) => _.prop === 'reissueType')
  pageRessiueType.value = value
  reissueTypeItem.value = reissueTypeListData.value
    .filter((_) => value.includes(_.value))
    .map((_) => _.label)
    .join('、')
  reissueTypeShow.value = false
}
async function getFlyCode() {
  // 获取飞控编码
  try {
    showToastLoading()
    let data = await getNameplateReissueEquipmentFlyCode(currentEquimentItem.value.serial_number)
    let flyCodeItem = infoArr.value.find((_) => _.prop === 'flightCode')
    if (data) {
      flyCodeItem.value = data.toLocaleUpperCase()
      flyCodeItem.valueError = false
    } else {
      flyCodeItem.valueError = true
      flyCodeItem.value = '当前设备未绑定飞控，请先绑定飞控再申请补办！'
    }
    clearToast()
  } catch (e) {
    clearToast()
    console.log(e)
  }
}
function itemInfoValueChangeHandle(item: ItemInfoProps) {
  console.log('itemInfoValueChangeHandle', item)
  if (item.prop === 'groundStation') {
    let groundStationItem = infoArr.value.find((_) => _.prop === 'groundStation')
    groundStationItem.value = item.value
  }
}
function showCreatedAtPopup() {
  createdAtPopupShow.value = true
}
function getParams() {
  let groundStationItem = infoArr.value.find((_) => _.prop === 'groundStation')
  let params: {
    serial_number: string
    namplate_types: Array<string>
    product_model: Array<string>
    ground_station_no?: string
    factory_at: number
  } = {
    serial_number: infoArr.value.find((_) => _.prop === 'sn').value as string,
    product_model: infoArr.value.find((_) => _.prop === 'product').value as Array<string>,
    namplate_types: pageRessiueType.value.map((_) => _) as Array<string>,
    factory_at: createdAt.value ? Math.floor(createdAt.value.getTime() / 1000) : 0,
  }
  if (groundStationItem) {
    console.log('groundStationItem', groundStationItem)
    params.ground_station_no = groundStationItem.value as string
  }
  return params
}
function setData(data: FillInEquipmentSetData) {
  currentSn.value = data.serial_number
  pageSn.value = data.serial_number
  currentRessiueType.value = data.namplate_types
  pageRessiueType.value = data.namplate_types

  reissueTypeListData.value = Object.keys(data.apply_namplate_types).map((_: string) => {
    return {
      value: _,
      label: data.apply_namplate_types[_],
    }
  })
  productNumbeTypeListData.value = data.product_models.map((_) => {
    return {
      label: _,
      value: _,
    }
  })
  currentProductNumber.value = data.product_model[0]
  pageProductNumber.value = data.product_model[0]
  currentEquimentItem.value.model_type = data.model_type
  infoArr.value = infoArr.value.map((_) => {
    switch (_.prop) {
      case 'sn':
        _.value = data.serial_number
        break
      case 'product':
        _.value = data.product_model
        if (data.product_models.length === 1) {
          delete _.clickHandle
          _.isShowArrowRight = false
        } else {
          _.isShowArrowRight = true
          _.clickHandle = clickHandle
        }
        break
      case 'reissueType':
        _.value = (data.namplate_types_text || []).join('、')
        break
      case 'factoryCode':
        _.value = data.serial_number
        break
      case 'flightCode':
        _.value = data.flight_control_no
        break
      case 'groundStation':
        _.value = data.ground_station_no || ''
        break
      case 'time':
        _.value = data.factory_at ? data.factory_at.split(' ')[0] : ''
        createdAt.value = _.value ? new Date(_.value) : getTodayStart()
        break
    }
    return _
  })
}

function confirmCreatedAt(value: Date) {
  createdAt.value = value
  hideCreatedAtPopup()
}
function hideCreatedAtPopup() {
  createdAtPopupShow.value = false
}
expose({
  getParams,
  setData,
  snActionShow,
  reissueTypeShow,
  productNumberActionShow,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(infoArr), (item, index) => {
      return (_openBlock(), _createBlock(ItemInfo, _mergeProps(item, {
        key: index,
        createdAt: createdAt.value,
        onValueChange: itemInfoValueChangeHandle,
        onShowCreatedAtPopup: showCreatedAtPopup
      }), null, 16, ["createdAt"]))
    }), 128)),
    _createVNode(PopCommonWrap, {
      show: _unref(snActionShow),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(snActionShow) ? (snActionShow).value = $event : snActionShow = $event)),
      title: "更换设备",
      "safe-area-inset-bottom": "",
      class: "pop-wrap",
      style: _normalizeStyle({ backgroundColor: 'rgba(246, 247, 248, 1)', minHeight: '80vh' })
    }, {
      default: _withCtx(() => [
        _createVNode(DeviceList, {
          data: deviceListData.value,
          refreshing: refreshing.value,
          "onUpdate:refreshing": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
          checked: _unref(currentSn),
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentSn) ? (currentSn).value = $event : currentSn = $event)),
          onOnRefresh: onRefresh,
          onConfirm: deviceListConfrimHandle
        }, null, 8, ["data", "refreshing", "checked"])
      ]),
      _: 1
    }, 8, ["show", "style"]),
    _createVNode(PopCommonWrap, {
      show: _unref(reissueTypeShow),
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_isRef(reissueTypeShow) ? (reissueTypeShow).value = $event : reissueTypeShow = $event)),
      "safe-area-inset-bottom": "",
      title: "补办类型（可多选）",
      class: "pop-wrap",
      style: { minHeight: '60vh' }
    }, {
      default: _withCtx(() => [
        _createVNode(ReissueTypeList, {
          checked: _unref(currentRessiueType),
          "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => (_isRef(currentRessiueType) ? (currentRessiueType).value = $event : currentRessiueType = $event)),
          data: reissueTypeListData.value,
          onConfirm: reissueTypeConfrimHandle
        }, null, 8, ["checked", "data"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(PopCommonWrap, {
      show: _unref(productNumberActionShow),
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_isRef(productNumberActionShow) ? (productNumberActionShow).value = $event : productNumberActionShow = $event)),
      title: "产品型号",
      class: "pop-wrap",
      style: { minHeight: '60vh' }
    }, {
      default: _withCtx(() => [
        _createVNode(ProductNumberTypeList, {
          data: _unref(productNumbeTypeListData),
          checked: _unref(pageProductNumber),
          "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pageProductNumber) ? (pageProductNumber).value = $event : pageProductNumber = $event)),
          onConfirm: productNumberConfrimHandle
        }, null, 8, ["data", "checked"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(PopCommonWrap, {
      show: createdAtPopupShow.value,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((createdAtPopupShow).value = $event)),
      title: "选择年月日",
      showHeader: false
    }, {
      default: _withCtx(() => [
        (createdAtPopupShow.value)
          ? (_openBlock(), _createBlock(_unref(DatetimePicker), {
              key: 0,
              modelValue: createdAt.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((createdAt).value = $event)),
              type: "date",
              title: "选择年月日",
              onConfirm: confirmCreatedAt,
              onCancel: hideCreatedAtPopup
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})